document.addEventListener('DOMContentLoaded', function () {
  const body = document.body;
  let scrollTimeout;

  const updateScrollState = () => {
    const scrollTop = window.scrollY || document.documentElement.scrollTop;
    const scrollHeight = document.documentElement.scrollHeight;
    const clientHeight = document.documentElement.clientHeight;

    // クラスの初期化
    body.classList.remove('scroll-start', 'scroll-mode', 'scroll-stop', 'scroll-end');

    // スクロール状態の判定
    if (scrollTop === 0) {
      body.classList.add('scroll-start'); // 一番上にスクロール
    } else if (scrollTop + clientHeight >= scrollHeight - 1) {
      body.classList.add('scroll-end'); // 一番下までスクロール
    } else {
      body.classList.add('scroll-mode'); // スクロール中
    }

    // スクロール停止時のクラス追加
    clearTimeout(scrollTimeout);
    scrollTimeout = setTimeout(() => {
      body.classList.remove('scroll-mode');
      body.classList.add('scroll-stop'); // スクロール停止
    }, 150); // スクロール停止判定の遅延
  };

  // 初期状態の設定
  updateScrollState();

  // スクロールイベントの監視
  window.addEventListener('scroll', updateScrollState);
});



// ヘッダーの高さに応じて .right-column, .section-slideshow, .navbar の余白や位置を算出
document.addEventListener('DOMContentLoaded', function () {
  const headerTop = document.querySelector('.header-top'); // .header-top の要素を取得
  const rightColumn = document.querySelector('.right-column'); // .right-column の要素を取得
  const sectionSlideshow = document.querySelector('.section-slideshow'); // .section-slideshow の要素を取得
  const navbar = document.querySelector('#navbar'); // #navbar の要素を取得

  if (!headerTop || !rightColumn || !navbar) {
    console.error('.header-top, .right-column または #navbar が見つかりません');
    return;
  }

  // 余白を設定する関数
  const updatePaddingAndPosition = function () {
    const headerHeight = headerTop.offsetHeight;
    const headerTopHeight = headerTop ? headerTop.offsetHeight : 0; // .page-header の高さ
    const sectionSlideshowHeight = sectionSlideshow ? sectionSlideshow.offsetHeight : 0; // .section-slideshow の高さ
    const additionalSpacing = 73; // 固定追加スペース
    const additionalSpacing02 = 10; // 固定追加スペース

    // 画面幅が 1001px 以上の場合
    if (window.innerWidth >= 1001) {
      // ① body.template-index の場合、.right-column .shopify-section:nth-child(2) に padding-top を設定
      if (document.body.classList.contains('template-index')) {
        const secondShopifySection = document.querySelector('.right-column .shopify-section:nth-child(2)');
        if (secondShopifySection) {
          secondShopifySection.style.paddingTop = (headerTopHeight + sectionSlideshowHeight + additionalSpacing) + 'px';
        }
      } else {
        const secondShopifySection = document.querySelector('.right-column .shopify-section:nth-child(1)');
        if (secondShopifySection) {
          secondShopifySection.style.paddingTop = (headerTopHeight + sectionSlideshowHeight + additionalSpacing02) + 'px';
        } 
      }

      // ② #navbar の top を設定
      if (document.body.classList.contains('template-index')) {
        navbar.style.paddingTop = (headerTopHeight + sectionSlideshowHeight + additionalSpacing) + 'px';
      } else {
        navbar.style.paddingTop = (headerTopHeight + additionalSpacing02) + 'px';
      }

      // .section-slideshow の padding-top を設定
      if (sectionSlideshow) {
        sectionSlideshow.style.paddingTop = headerHeight + 'px';
      }
    } else {
      const headerHeight = headerTop.offsetHeight;

    // .right-column に padding-top を設定
    rightColumn.style.paddingTop = headerHeight + 'px';
    
      // 画面幅が 1000px 以下の場合、リセット
      navbar.style.paddingTop = '';
      if (sectionSlideshow) {
        sectionSlideshow.style.paddingTop = '';
      }
      const secondShopifySection = document.querySelector('.right-column .shopify-section:nth-child(2)');
      if (secondShopifySection) {
        secondShopifySection.style.paddingTop = '';
      }
    }
  };

  // 初期設定
  updatePaddingAndPosition();

  // ウィンドウリサイズ時に再計算
  window.addEventListener('resize', updatePaddingAndPosition);
});


// 「TOPへ戻る」アンカーリンクの#消す
$('.back-top a').click(function() {
  // スクロールの速さ
  var speed = 400;
  var href= $(this).attr("href");
  var $target = $(href == "#" || href == "" ? 'html' : href);
  var position = $target.offset().top;
  $('body,html').animate({scrollTop:position}, speed, 'swing');

  return false;
});

document.addEventListener('DOMContentLoaded', function () {
  const floatingContainer = document.getElementById('id_sb_floating_container');
  const backTop = document.querySelector('.back-top');
  const body = document.body;
  const closeMark = floatingContainer ? floatingContainer.querySelector('.closeMark') : null;

  if (!backTop) {
    console.error('.back-top 要素が見つかりません');
    return;
  }

  // 初期状態の更新
  const updateFloatingState = function () {
    if (floatingContainer && getComputedStyle(floatingContainer).display !== 'none') {
      const containerHeight = floatingContainer.offsetHeight;
      body.classList.add('floating_banner');
      body.classList.remove('floating_banner_none');
      backTop.style.bottom = `${containerHeight + 20}px`;
    } else {
      body.classList.remove('floating_banner');
      body.classList.add('floating_banner_none');
      backTop.style.bottom = ''; // 初期状態に戻す
    }
  };

  // 初期読み込み時の処理
  updateFloatingState();

  // 「.closeMark」がクリックされた場合の処理
  if (closeMark) {
    closeMark.addEventListener('click', function () {
      // #id_sb_floating_container を非表示にする処理がここにある場合
      floatingContainer.style.display = 'none'; // 例: 非表示処理

      // 状態を更新
      updateFloatingState();
    });
  }

  // #id_sb_floating_container の状態変化を監視する
  const observer = new MutationObserver(() => {
    updateFloatingState();
  });

  if (floatingContainer) {
    observer.observe(floatingContainer, {
      attributes: true, // 属性の変化を監視
      attributeFilter: ['style'], // style 属性の変更を監視
    });
  }
});
